<template>
  <aside v-if="visible" class="update-available" role="status" aria-live="polite" aria-label="Application update available">
    <span class="update-available__icon icon-update-21" aria-hidden="true"></span>
    <div class="update-available__content">
      <strong>New version of Jidoka available</strong>
      <span>Refresh to load the latest version</span>
    </div>
    <div class="update-available__actions">
      <button type="button" class="button pill -text" :disabled="refreshing" @click="dismiss">Later</button>
      <button type="button" class="button pill -blue" :disabled="refreshing" @click="refresh">
        {{ refreshing ? 'Refreshing…' : 'Refresh now' }}
      </button>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import {
  UPDATE_AVAILABLE_EVENT,
  UPDATE_FAILED_EVENT,
  UPDATE_STARTED_EVENT,
  versionManager
} from '@/modules/updates/versionManager';
import type { UpdateAvailableDetail } from '@/modules/updates/versionManager';

const visible = ref(false);
const refreshing = ref(false);

const DISMISSED_KEY = 'JIDOKA_DISMISSED_BUILD';
const show = (event?: Event) => {
  const detail = (event as CustomEvent<UpdateAvailableDetail> | undefined)?.detail;
  const buildId = detail?.availableBuildId || versionManager.availableBuildId;
  if (buildId && sessionStorage.getItem(DISMISSED_KEY) === buildId) return;
  visible.value = true;
};
const dismiss = () => {
  if (versionManager.availableBuildId) sessionStorage.setItem(DISMISSED_KEY, versionManager.availableBuildId);
  visible.value = false;
};
const markStarted = () => { refreshing.value = true; visible.value = true; };
const markFailed = () => { refreshing.value = false; };
const refresh = () => { void versionManager.refreshToLatest(); };

onMounted(() => {
  window.addEventListener(UPDATE_AVAILABLE_EVENT, show);
  window.addEventListener(UPDATE_STARTED_EVENT, markStarted);
  window.addEventListener(UPDATE_FAILED_EVENT, markFailed);
  if (versionManager.availableBuildId && versionManager.availableBuildId !== versionManager.currentBuildId) show();
});

onUnmounted(() => {
  window.removeEventListener(UPDATE_AVAILABLE_EVENT, show);
  window.removeEventListener(UPDATE_STARTED_EVENT, markStarted);
  window.removeEventListener(UPDATE_FAILED_EVENT, markFailed);
});
</script>
